module.exports = "/assets/0e725f7e436b0c0707e29f25e49232eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/U7.png
// module id = 1881
// module chunks = 0